import testDevice from '@/view/front/test/device'
import devices from '@/view/front/device/devices'
import template from '@/view/front/device/template'
import templateVariable from '@/view/front/device/templateVariable'
import group from '@/view/front/group/team'
import scheduledTask from '@/view/front/device/scheduledTask'
import templateTrigger from '@/view/front/device/templateTrigger'
import templateVariableTrigger from '@/view/front/device/templateVariableTrigger'
import maintenanceHelpOrder from '@/view/front/order/maintenanceHelpOrder'
import maintenanceOrder from '@/view/front/order/maintenanceOrder'
import alarmLog from '@/view/front/log/alarmLog'
import analysisLog from '@/view/front/log/analysisLog'
import deviceDetail from '@/view/front/device/deviceDetail'
import deviceInfo from '@/view/front/device/deviceInfo'
import chemicalsConfig from '@/view/system/chemicalsConfig'
import chemicalsDeviceStatistics from '@/view/system/chemicalsDeviceStatistics'
import standard from '@/view/system/standard'
import messagManager from '@/view/front/message/cmMessage'
import message from '@/view/front/message/message'

import chemicals from '@/view/front/operation/chemicals'
import scroll from '@/view/front/operation/institutionScrollImg'
import information from '@/view/front/operation/institutionInformation'
import chemicalsStore from '@/view/front/operation/chemicalsDeviceStore'
import sim from '@/view/front/order/maintenanceSim'
import simManager from '@/view/front/order/maintenanceSimManager'


export default [{
	path: 'standard',
	name: 'standard',
	component: standard
},{
	path: 'chemicalsConfig',
	name: 'chemicalsConfig',
	component: chemicalsConfig
},{
	path: 'chemicalsDeviceStatistics',
	name: 'chemicalsDeviceStatistics',
	component: chemicalsDeviceStatistics
},{
	path: 'front/device/deviceDetail',
	name: 'deviceDetail',
	component: deviceDetail
},{
	path: 'front/device/deviceInfo',
	name: 'deviceInfo',
	component: deviceInfo
},{
	path: 'front/analysisLog',
	name: 'analysisLog',
	component: analysisLog
}, {
	path: 'front/alarmLog',
	name: 'alarmLog',
	component: alarmLog,
}, {
	path: 'front/maintenanceHelpOrder',
	name: 'maintenanceHelpOrder',
	component: maintenanceHelpOrder,
}, {
	path: 'front/maintenanceOrder',
	name: 'maintenanceOrder',
	component: maintenanceOrder,
}, {
	path: 'front/device/task',
	name: 'scheduledTask',
	component: scheduledTask,
}, {
	path: 'front/template/trigger',
	name: 'templateTrigger',
	component: templateTrigger,
}, {
	path: 'front/alone/trigger',
	name: 'templateVariableTrigger',
	component: templateVariableTrigger,
}, {
	path: 'front/group',
	name: 'group',
	component: group,
}, {
	path: 'front/device/devices',
	name: 'devices',
	component: devices,
}, {
	path: 'front/device/template',
	name: 'template',
	component: template,
}, {
	path: 'front/device/templateVariable',
	name: 'templateVariable',
	component: templateVariable,
}, {
	path: 'front/test/device',
	name: 'testDevice',
	component: testDevice,
}, {
	path: 'message/manager',
	name: 'messagManager',
	component: messagManager,
}, {
	path: 'message',
	name: 'message',
	component: message,
}, {
	path: 'chemicals',
	name: 'chemicals',
	component: chemicals,
}, {
	path: 'scroll',
	name: 'scroll',
	component: scroll,
}, {
	path: 'information',
	name: 'information',
	component: information,
}, {
	path: 'chemicalsLog',
	name: 'chemicalsStore',
	component: chemicalsStore,
}, {
	path: 'sim',
	name: 'sim',
	component: sim,
}, {
	path: 'simManager',
	name: 'simManager',
	component: simManager,
}]


// WEBPACK FOOTER //
// ./src/router/front.js